var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.vtableData,"columns":_vm.tableColumns,"size":"mini"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }